import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const RecipientsListConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "recipientsList" */
      '../../../components/MoneyManagement/RecipientsList'
    ),
  releaseState: 'preview',
  enabledOverrideFlag: ComponentOverrideFlag.recipients_list,
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays a list of recipients.',
  friendlyName: 'Recipients list',
  enableV2APIToken: true,
};
